import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./ToolsMenu.css";

const TOOLS = [
  {
    id: "prompt-in",
    label: "Prompt IN",
    description: "Entrada y refinamiento de prompts",
    path: "/keyframes/prompt-in",
    active: true,
    group: "Crear Imagen",
    permission: "tools.keyframes",
  },
  {
    id: "mdv",
    label: "MDV",
    description: "Mesa de Validaci\u00f3n de prompts",
    path: "/keyframes/mdv",
    active: true,
    group: "Crear Imagen",
    permission: "tools.mdv",
  },
  {
    id: "prompter",
    label: "Prompter",
    description: "Generador de fotograf\u00eda fotorrealista",
    path: "/keyframes/prompter",
    active: true,
    group: "Crear Imagen",
    permission: "tools.keyframes",
  },
  {
    id: "character-design",
    label: "Crea Personaje",
    description: "Dise\u00f1a y genera vistas faciales del personaje",
    path: "/character-design",
    active: true,
    group: "Crear Sets",
    permission: "tools.characters",
  },
  {
    id: "characters",
    label: "Crea Hoja Personaje",
    description: "Genera character sheets con vestuario personalizado",
    path: "/characters",
    active: true,
    group: "Crear Sets",
    permission: "tools.characters",
  },
  {
    id: "wardrobe",
    label: "Crear Ropa",
    description: "Sube referencias de ropa y genera variaciones con IA",
    path: "/wardrobe",
    active: true,
    group: "Crear Sets",
    permission: "tools.wardrobe",
  },
  {
    id: "scenes",
    label: "Crea Escena",
    description: "Gestiona escenarios y genera variaciones con IA",
    path: "/scenes",
    active: true,
    group: "Crear Sets",
    permission: "tools.scenes",
  },
  {
    id: "video",
    label: "Genera Video",
    description: "Comp\u00f3n escena + personajes + prompt cinematogr\u00e1fico",
    path: "/video",
    active: true,
    group: "Crear Video",
    permission: "tools.video",
  },
  {
    id: "video-set",
    label: "Video Set",
    description: "Set de grabaci\u00f3n con referencias visuales (Seedance 2.0)",
    path: "/video-set",
    active: true,
    group: "Crear Video",
    permission: "tools.videoset",
  },
];

export default function ToolsMenu({ can = () => true }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Filter tools by permissions using can()
  const visibleTools = TOOLS.filter(
    (t) => !t.permission || can(t.permission)
  );

  // Detectar herramienta activa por la ruta (más específica primero)
  const activeTool =
    [...visibleTools].sort((a, b) => b.path.length - a.path.length)
      .find((t) => location.pathname.startsWith(t.path)) || visibleTools[0];

  if (!activeTool) return null;

  // Cerrar al click fuera
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const selectTool = (tool) => {
    if (!tool.active) return;
    setOpen(false);
    navigate(tool.path);
  };

  // Group tools for rendering
  const renderTools = () => {
    const items = [];
    let lastGroup = null;
    for (const tool of visibleTools) {
      if (tool.group && tool.group !== lastGroup) {
        items.push(
          <div key={`group-${tool.group}`} className="tools-menu-group">
            {tool.group}
          </div>
        );
        lastGroup = tool.group;
      }
      items.push(
        <div
          key={tool.id}
          className={`tools-menu-item ${tool.group ? "tools-menu-item--indented" : ""} ${tool.id === activeTool.id ? "active" : ""} ${!tool.active ? "disabled" : ""}`}
          onClick={() => selectTool(tool)}
        >
          <div className="tools-menu-item-label">
            {tool.label}
            {!tool.active && <span className="tools-soon-badge">pronto</span>}
          </div>
          <div className="tools-menu-item-desc">{tool.description}</div>
        </div>
      );
    }
    return items;
  };

  return (
    <div className="tools-menu" ref={ref}>
      <button
        className={`tools-menu-trigger ${open ? "open" : ""}`}
        onClick={() => setOpen(!open)}
      >
        <span className="tools-menu-label">Tools</span>
        <span className="tools-menu-current">{activeTool.label}</span>
        <span className="tools-menu-chevron">{open ? "▴" : "▾"}</span>
      </button>

      {open && (
        <div className="tools-menu-dropdown">
          {renderTools()}
        </div>
      )}
    </div>
  );
}
